import React from 'react';
import noData from '../../assets/images/no-data.png';

const EmptyView = ({ message }) => {
    
    return (
        <div className='col-12 text-center mt-5'>
            <img src={noData} alt="image"  height="20%"/>
            <h5 className='mt-3'>{message}</h5>
        </div>
    );
};

export default EmptyView;
